import { useNavigate } from 'react-router-dom';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { OnboardingChoiceScreen } from './OnboardingChoiceScreen';

export const GetStartedPage = () => {
    const navigate = useNavigate();

    return (
        <OnboardingChoiceScreen
            pageTitle="Welcome"
            title="You're all set!"
            description="Your account has been created successfully. What would you like to do next?"
            icon={faCircleCheck}
            onNewProject={() => navigate('/new-project')}
            onExistingProject={() => navigate('/')}
        />
    );
};
